<template>
  <div id="map" class="map"></div>
</template>
<script>
import gmapsInit from "@/utils/gmaps";

let google = null;
let coder = null;
let map = null;

export default {
  name: "Map",
  props: {
    address: {
      type: String,
      default: "Toronto, Ontario",
    },
    lat: {
      type: Number,
      default: null,
    },
    lng: {
      type: Number,
      default: null,
    },
    defaultZoom: {
      type: Number,
      default: 7,
    },
    markers: {
      type: Array,
      required: true,
    },
    allowDrawing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      closeZoom: 12,
      coder: null,
      latLng: false,
      drawingManager: null,
      drawnShapes: [],
    };
  },
  async mounted() {
    if (typeof this.markers !== "undefined") {
      try {
        google = await gmapsInit();
        coder = await new google.maps.Geocoder();
        map = await new google.maps.Map(document.getElementById("map"), {
          zoom: this.defaultZoom,
        });
        this.render();
        await this.geocode();
        this.plotMarkers(this.markers);
        if (this.allowDrawing) {
          this.initDrawing();
        }
      } catch (error) {}
    }
  },
  methods: {
    render: function () {
      map.setOptions({
        maxZoom: 16,
        minZoom: 2,
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });
    },
    geocode: async function () {
      if (this.lat && this.lng) {
        map.setCenter({
          lat: this.lat,
          lng: this.lng,
        });
      } else if (this.address) {
        coder.geocode({ address: this.address }, (results, status) => {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          map.setCenter(results[0].geometry.location);
        });
      }
    },
    markerClickHandler: function (marker) {
      map.setZoom(this.closeZoom);
      map.panTo(marker.getPosition());
    },
    plotMarkers: function () {
      this.markers.filter(
        function (m) {
          let latLng = { lat: m.lat, lng: m.lng };
          new google.maps.Marker({
            map: map,
            icon: new google.maps.MarkerImage(
              "/images/map-avatars/current-location.gif",
              null,
              null,
              null,
              new google.maps.Size(24, 37.5)
            ),
            position: latLng,
            metadata: m.meta,
          });
        }.bind(this)
      );
    },
    initDrawing: function () {
      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["polygon", "circle", "rectangle"],
        },
        polygonOptions: {
          fillColor: "#00FF00",
          fillOpacity: 0.2,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          clickable: true,
          editable: false,
          zIndex: 1,
        },
        circleOptions: {
          fillColor: "#00FF00",
          fillOpacity: 0.2,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          clickable: true,
          editable: false,
          zIndex: 1,
        },
        rectangleOptions: {
          fillColor: "#00FF00",
          fillOpacity: 0.2,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          clickable: true,
          editable: false,
          zIndex: 1,
        },
      });

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        (event) => {
          if (event.type === google.maps.drawing.OverlayType.POLYGON) {
            this.drawnShapes.push(event.overlay);

            const paths = event.overlay
              .getPath()
              .getArray()
              .map((latLng) => ({
                lat: latLng.lat(),
                lng: latLng.lng(),
              }));

            this.$emit("areaSelected", { type: "polygon", paths });
          } else if (event.type === google.maps.drawing.OverlayType.CIRCLE) {
            this.drawnShapes.push(event.overlay);

            const center = event.overlay.getCenter();
            const radius = event.overlay.getRadius();

            this.$emit("areaSelected", { type: "circle", center, radius });
          } else if (event.type === google.maps.drawing.OverlayType.RECTANGLE) {
            this.drawnShapes.push(event.overlay);

            const bounds = event.overlay.getBounds();
            const ne = bounds.getNorthEast();
            const sw = bounds.getSouthWest();

            this.$emit("areaSelected", { type: "rectangle", ne, sw });
          }
        }
      );
    },
    startDrawing: function () {
      this.drawingManager.setMap(map);
      this.drawingManager.setDrawingMode(
        google.maps.drawing.OverlayType.POLYGON
      );
    },
    stopDrawing: function () {
      this.drawingManager.setMap(null);
    },
    clearSelectedAreas: function () {
      this.drawnShapes.forEach((shape) => {
        shape.setMap(null);
      });
      this.drawnShapes = [];
    },
  },
};
</script>
